<!--
 * @Description: 请修改成厚
 * @Version: 1.0
 * @Author: lvzhou
 * @Date: 2019-10-16 21:27:48
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-05-31 09:13:49
 -->
<template>
  <!--表格-->
  <div class="table_box">
    <!--表格配置-->
    <el-table
      v-loading="tableLoading"
      stripe :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        background: '#EEF1F6',
        color: 'rgba(41,44,53,0.7)',
      }">
      <!--表格配置 end-->

      <!-- <template slot="empty">
        <div
          class="v2-table__empty-data v2-table__empty-border"
          style="width: 100%">
          <div
            class="v2-table__empty-default">
            <el-empty
              description="暂无数据" />
          </div>
        </div>
      </template> -->


      <!--循环条目配置-->

      <!-- <el-table-column prop="index"
                    label="序号"
                    width="140">
      </el-table-column> -->

      <el-table-column prop="userName"
                    label="用户名"
                    width="120">
      </el-table-column>

      <el-table-column prop="operateTime"
                    label="操作时间"
                    width="180">
      </el-table-column>

      <el-table-column prop="errorMessage"
                    label="异常内容"
                    min-width="240"
                    show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="params"
                    label="参数"
                    min-width="240"
                    show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="url"
                    label="接口地址"
                    min-width="200"
                    show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="position"
                    label="异常位置"
                    min-width="200"
                    show-overflow-tooltip>
      </el-table-column>


      <!-- <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :fixed="item.fixed"
        :prop="item.key"
        :label="item.title"
        :min-width="item.minwidth"
        :sortable="item.sortable"
        :filters="item.filters"
        :align="item.align"
        :filter-method="item.filters && filterHandler"
        :show-overflow-tooltip="item.tooltop">

        <template
          slot-scope="scope">
          <template
            v-if="item.key == 'actions'">

            <el-button
              type="danger"
              size="mini"
              @click="$emit('del',scope.row)">删除</el-button>
          </template>
          <template
            v-else-if="item.key == 'index'">
            {{ scope.$index + 1 }}
          </template>

          <template
            v-else-if="item.key == 'type'">
            <span
              v-if="scope.row.type=='3'">GPT3.5</span>
            <span
              v-if="scope.row.type=='4'">GPT4</span>
          </template>
          <template
            v-else-if="item.key == 'state'">
            <el-switch
              v-model="scope.row.state"
              :active-value="0"
              :inactive-value="1"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="$emit('edit',scope.row)" />

          </template>
          <template
            v-else>{{ scope.row[item.key] }}</template>
        </template>
      </el-table-column> -->



    </el-table>
    <!--分页配置-->
    <div
      style="margin-top: 20px; height: 40px;text-align: right;">
      <el-pagination
        class="fr"
        :current-page="pageNumber"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <!--分页end-->
  </div>
</template>

<script>
// 引入组件及方法
import { mapGetters } from 'vuex'
export default {
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表头项
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 加载状态
    tableLoading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    tableClass: { type: String, default: '' }, // 表格样式
    pageSize: { type: Number, default: 10 }, // 当前页
    pageNumber: { type: Number, default: 1 }, // 每页显示条数
    total: { type: Number, default: 0 }, // 总数据
    isSelection: { type: Boolean, default: false } // 选中项
  },
  // 数据
  data() {
    return {
      // 表头
    }
  },

  methods: {
    // 过滤表头
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    // 修改翻页
    handleSizeChange(e) {
      this.$emit('changePage', {
        pageNumber: this.pageNumber,
        pageSize: e
      })
    },
    // 设置每页条数
    handleCurrentChange(e) {
      this.$emit('changePage', {
        pageNumber: e,
        pageSize: this.pageSize
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table_box {
  position: relative;
  .table_icon {
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 4px;
    background: #dde2e8;
    text-align: center;
    line-height: 22px;
    z-index: 999;
    right: 20px;
    top: 15px;
    cursor: pointer;
  }
}
</style>
